'use strict';

define(['$window'], function ($window) {

  var component = {};
  var _config = {
    videoPlayerContainer: '.videoHeroBanner_container',
    videoPlayer: 'videoHeroBanner_videoPlayer',
    videoPlayerButton: 'videoHeroBanner_videoPlayButton',
    videoImageAndPlayButtonContainer: 'videoHeroBanner_videoImageAndPlayButtonContainer',
    videoImageAndPlayButtonContainerHidden: 'videoHeroBanner_videoImageAndPlayButtonContainerHidden',
    imageAsset: 'img.videoHeroBanner_videoImageAsset',
    videoImage: '.videoHeroBanner_videoImage'
  };

  var videoHeroBanner = function videoHeroBanner() {
    var _init = function _init(element) {

      component.element = element;
      component.videoContainers = document.querySelectorAll(component.config.videoPlayerContainer);

      component.findAndBindWidgets();

      var cachedWidth = $window.screen.width;
      $window.addEventListener('resize', component.updateContainerHeight.bind(null, cachedWidth));
    };

    var _findAndBindWidgets = function _findAndBindWidgets() {
      component.videoContainers.forEach(function (container) {
        var widgetId = container.getAttribute('data-widget-id');
        if (widgetId) {
          var videoPlayButton = container.querySelector('#' + component.config.videoPlayerButton + '-' + widgetId);
          var player = container.querySelector('#' + component.config.videoPlayer + '-' + widgetId);
          videoPlayButton.addEventListener('click', component.playVideo.bind(null, widgetId, player));
        }
      });

      component.updateContainerHeight();
    };

    var _playVideo = function _playVideo(widgetId, videoPlayer) {
      var imageAndPlayButtonContainer = document.getElementById(component.config.videoImageAndPlayButtonContainer + '-' + widgetId);
      imageAndPlayButtonContainer.classList.add(component.config.videoImageAndPlayButtonContainerHidden);
      imageAndPlayButtonContainer.addEventListener('transitonend', function hideBannerAndFocusOnVideo() {
        imageAndPlayButtonContainer.hidden = true;
        videoPlayer.focus();
        imageAndPlayButtonContainer.removeEventListener('transitionend', hideBannerAndFocusOnVideo);
      });

      var parent = videoPlayer.parentNode;
      if (parent) {
        parent.style.height = '100%';
        videoPlayer.style.height = '100%';
      }
      videoPlayer.removeAttribute('aria-hidden');
      videoPlayer.removeAttribute('tabindex');
      videoPlayer.play();
    };

    var _updateContainerHeight = function _updateContainerHeight(cachedWidth) {
      if ($window.screen.width !== cachedWidth) {
        var imageAsset = component.element.querySelector(component.config.imageAsset);
        if (imageAsset) {
          var widgetId = imageAsset.parentNode.parentNode.getAttribute('data-widget-id');
          var widgetHeight = parseInt(window.getComputedStyle(imageAsset).height) + 'px';
          component.setContainerHeight(widgetHeight, widgetId);
        }
      }
    };

    var _setContainerHeight = function _setContainerHeight(height, widgetId) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = component.videoContainers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var container = _step.value;

          if (container.getAttribute('data-widget-id') === widgetId) {
            container.style.height = height;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    };

    component.config = _config;
    component.init = _init;
    component.findAndBindWidgets = _findAndBindWidgets;
    component.playVideo = _playVideo;
    component.updateContainerHeight = _updateContainerHeight;
    component.setContainerHeight = _setContainerHeight;

    return component;
  };

  return videoHeroBanner;
});
//# sourceMappingURL=videoHeroBanner.js.map
